<template>
    <v-dialog
      v-model="modalIsOpen"
      scrollable
      max-width="100vw"
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on , attrs }">
        <v-btn
          class="ItineraryButton"
          color="primary"
          dark
          v-show="display"
          v-bind="attrs"
          v-on="on"
        >
          Itinerary detail
          <v-icon right small>
            mdi-arrow-right-circle-outline
          </v-icon>
        </v-btn>
      </template>

      <v-card class="ItineraryCard">
        <v-card-title class="font-weight-bold sticky">
          {{ processID }}
          <v-chip
            label
            outlined
            color="primary"
            small
            text-color="primary"
          >
            {{setDeliveryStatusTitle()}}
          </v-chip>
          <div class="itinerary__more mx-3">
            <v-btn
              color="primary"
              class="itinerary__more-details"
              @click="expandAll"
              small
              v-if="BtnVisibility === 'true'"
            >
              {{ !expand ? 'Expand details' : 'Compact details' }}
            </v-btn>
          </div>
          <div class="refresh">
            <v-btn
              color="primary"
              class="itinerary__refresh"
              :loading="loading"
              :disabled="loading"
              @click="getDeliveryStatus"
              small
            >
              Refresh <v-icon class="ml-2" small>mdi-cached</v-icon>
              <template v-slot:loader>
                <span>Loading...</span>
              </template>
            </v-btn>
            <span class="primary--text subtitle-2 font-weight-bold ml-4" v-if="error">
              Something went wrong. Please try again later.
            </span>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            elevation="0"
            @click="modalIsOpen = false"
            right
            fab
            x-small
          >
            <v-icon small>
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>

        <v-divider class="mb-6"></v-divider>

        <v-container class="ItineraryCardContainer">
          <v-row class="d-flex justify-start">
            <v-col cols="6" md="7">
              <v-timeline
                class="modalItinerary pt-0"
              >
                <div class="itinerary__set" v-for="(data, index) in newModalData" :key="index">
                  <div class="itinerary__set-wrap">
                    <v-timeline-item
                      v-for="(item, index) in retrieveDataItems(data)"
                      :key="item.point_id"
                      :color="colorStateProgress(item)"
                      :icon="setIcon(item)"
                      :medium="isFirstOrLast(index, data)"
                      :small="!isFirstOrLast(index, data)"
                      right
                      @mouseover.native="item.tooltip = true"
                      @mouseleave.native="item.tooltip = false"
                    >
                      <span
                        :slot="$vuetify.breakpoint.mdAndUp
                          ? 'opposite'
                          : 'default'"
                        :style="$vuetify.breakpoint.mdAndUp
                          ? 'flex-shrink:1;flex-grow:0;'
                          :'white-space:nowrap'"
                        :class="!isFirstOrLast(index, data)
                          ? 'font-weight-normal subtitle-2'
                          : 'font-weight-bold'"
                      >
                        {{ statusTranslate(item.activity_code) }}
                      </span>

                      <v-tooltip
                        v-model="item.tooltip"
                        :max-width="$vuetify.breakpoint.mdAndUp ? '30%':'50%'"
                        color="#e1e5eb"
                        right
                      >
                        <template v-slot:activator="{ on }">
                          <div
                            v-on="on"
                            :style="$vuetify.breakpoint.mdAndUp
                              ? 'white-space:nowrap'
                              : 'width:fit-content'"
                          >
                            <div
                              :class="!isFirstOrLast(index, data)
                                ? 'font-weight-normal body-2'
                                : 'font-weight-medium'"
                            >
                              <span>{{ setLocation(item) }}</span>
                            </div>

                            <div
                              :class="!isFirstOrLast(index, data)
                                ? 'CurrentDateIntermediate'
                                : 'CurrentDate'"
                            >
                              {{ setDate(item) }}
                            </div>
                            <div
                              v-if="flightNumber(item)"
                              class="caption grey--text text--darken-1"
                            >
                              <strong>Flight number: </strong>
                              {{ flightNumber(item).specific_data_value }}
                            </div>
                          </div>
                        </template>

                        <v-container class="tooltipContainer pr-0 pl-0">
                          <v-icon color="rgb(55,1,235)">mdi-map-marker-outline</v-icon>
                          <v-row class="text-center mt-0 pt-0">
                            <v-col cols="12" class="mb-0 pb-0 mt-0 pt-0 pr-0 pl-0">
                              <strong>{{ item.corporate_name }}</strong>
                            </v-col>

                            <v-col cols="12" class="mb-0 pb-0 pr-0 pl-0">
                              <p class="text-center mb-0">
                                {{ item.address }}<br>{{ setLocation(item) }}
                              </p>
                            </v-col>

                            <v-col cols="12" class="mb-0 pb-0 pr-0 pl-0">
                              <p class="text-center mb-0">
                                <b class="tooltip-EST-Date">
                                  EST. {{ setModalDate(item.estimated_ending_maximum_date) }}
                                </b><br>
                                <b class="tooltip-ACT-Date" v-if="item.transit_confirmed">
                                  ACT. {{ setModalDate(item.ending_date) }}
                                </b>
                              </p>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-tooltip>
                    </v-timeline-item>
                  </div>
                </div>
              </v-timeline>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'app-itinerary-modal',
  props: {
    processID: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      BtnVisibility: false,
      display: false,
      expand: false,
      modalIsOpen: false,
      error: false,
      loading: true,
      originalState: [],
      client: 'MN-55901 ROCHESTER US',
      showDeliveryStatus: false,
      legsData: [],
      newModalData: [],
      details: [],
    };
  },
  watch: {
    processID: {
      immediate: true,
      handler() {
        this.BtnVisibility = false;
        this.display = false;
        this.expand = false;
        this.showDeliveryStatus = false;
        this.originalState = [];
        this.legsData = [];
        this.details = [];
        this.getDeliveryStatus();
      },
    },
  },
  methods: {
    statusTranslate(activityCode) {
      return this.$lang.translate(`details.majorSteps.${activityCode}`) || activityCode;
    },
    setLineColorProgress() {
      let allShowItems = [];
      let itemsConfirmed = 0;
      let ConfirmedItems = 0;
      if (this.expand === true) {
        // eslint-disable-next-line
        this.newModalData.forEach((item) => {
          allShowItems = allShowItems.concat(item.start, item.between, item.end);
        });
        ConfirmedItems = allShowItems.filter(item => item.transit_confirmed === true).length;
        itemsConfirmed = Math.round((ConfirmedItems * 100) / allShowItems.length);
      } else {
        this.newModalData.forEach((item) => {
          allShowItems = allShowItems.concat(item.start, item.end);
        });
        ConfirmedItems = allShowItems.filter(item => item.transit_confirmed === true).length;
        itemsConfirmed = Math.round((ConfirmedItems * 100) / allShowItems.length);
      }
      const styleElem = document.head.appendChild(document.createElement('style'));
      styleElem.innerHTML = `.modalItinerary:before {border-image: linear-gradient(to bottom, #55B083 0% ${itemsConfirmed}%,gray 0%) 1 100%!important}`;
    },
    expandAll() {
      this.expand = !this.expand;
      this.newModalData.map((step) => {
        // eslint-disable-next-line
        step.details = !step.details;
        return step;
      });
      this.setLineColorProgress();
    },
    isFirstOrLast(index, items) {
      return index === 0 || index === this.retrieveDataItems(items).length - 1;
    },
    retrieveDataItems(data) {
      return [
        ...data.start,
        ...(data.details ? data.between : []),
        ...data.end,
      ].filter(Boolean);
    },
    getSubcontractOrders(legs) {
      if (!window._.isArray(legs)) return [];

      return legs
        .filter(l => l.subcontracting_order_id)
        .map(l => l.subcontracting_order_id);
    },
    async getLegs() {
      return window._.get(
        await axios.get(`/dynamicitirenary/legs?cso=${this.processID}`),
        'data',
      );
    },
    getSteps(orders) {
      return Promise.all(orders.map(cso => axios.get(
        `/dynamicitirenary/steps?cso=${cso}`,
      )));
    },

    /**
     * @param {Array}
     * @param {String} code
     * @param {Number}
     */
    getFirstStep(steps, code) {
      const index = steps.findIndex(s => s.activity_code === code);
      return ~index ? index + 1 : 1;
    },

    /**
     * @param {Array} steps
     * @param {String} code
     * @returns {Number}
     */
    getLastStep(steps, code) {
      let index = window._
        .cloneDeep(steps)
        .reverse()
        .findIndex(s => s.activity_code === code);

      if (!~index) index = 0;

      return steps.length - index - 1;
    },
    async checkValid(legs) {
      if (!window.ENV.itinerary.can) return legs;

      try {
        return window._.chain(await axios.post('/dynamicitirenary/can', legs))
          .get('data')
          .entries()
          .filter(([, v]) => (
            v.some(p => (
              p.specific_data_code === 'EDIRID'
              && p.specific_data_value === 'DYNAMIC'
            ))
          ))
          .map(([key]) => key)
          .value();
      } catch (err) {
        console.log(err);
        return [];
      }
    },
    async getDeliveryStatus() {
      this.error = false;
      this.loading = true;

      try {
        const legs = await this.getLegs();
        const orders = await this.checkValid(this.getSubcontractOrders(legs));
        const steps = await this.getSteps(orders);

        if (steps.length) this.display = true;
        this.legsData = legs;
        this.newModalData = steps.reduce((acc, i) => {
          const item = window._.cloneDeep(i.data);
          // boarding and landing has a reference to an index between the item array.
          const boarding = this.getFirstStep(item, 'EMBARQUEME');
          const landing = this.getLastStep(item, 'DEBARQUEME');

          acc.push({
            details: this.expand,
            start: item.slice(0, boarding),
            end: item.slice(landing, item.length),
            between: item.slice(boarding, landing),
          });

          return acc;
        }, []);

        if (this.newModalData.length > 0) {
          this.BtnVisibility = this.newModalData[0].between <= 0 ? 'false' : 'true';
          this.setLineColorProgress();
        }
      } catch (err) {
        console.error(err);
        this.error = true;
      }

      this.loading = false;
    },
    setDate(item) {
      return item.transit_confirmed && item.ending_date !== ''
        ? `ACT. ${moment(item.ending_date).format('L h:mm a')}`
        : `EST. ${moment(item.estimated_ending_maximum_date).format('L h:mm a')}`;
    },
    setModalDate(value) {
      return moment(value).format('L h:mm a');
    },
    setLocation(item) {
      return `${item.corporate_name} ${item.location} ${item.country_code}`;
    },
    flightNumber(item) {
      if (!window.ENV.itinerary.flightNumber) return false;
      return item.specific_data_list.find(d => d.specific_data_code === 'FLINUM');
    },
    setIcon(item) {
      switch (item.activity_code) {
        case 'CHARGEMENT':
        case 'PICK-UP':
          return 'mdi-calendar-check';
        case 'DECHARGEME':
        case 'DELIVERY':
          return 'mdi-map-marker-outline';
        default:
          return '';
      }
    },
    setDeliveryStatusTitle() {
      if (
        this.legsData.length <= 0
        || !window._.isArray(this.legsData)
      ) {
        return '';
      }

      return this.legsData.slice(-1).pop().transit_confirmed
        ? 'Completed'
        : 'On going';
    },
    colorStateProgress(prop) {
      if (prop.transit_confirmed === null) {
        return 'rgb(55,1,235)';
      }
      if (prop.transit_confirmed === true) {
        return 'rgb(85,176,131)';
      }
      return 'grey';
    },
    progressLineLength() {
      const items = this.newModalData.length;
      if (items <= 3) {
        return '65%';
      }
      if (items <= 5) {
        return '85%';
      }
      if (items <= 6) {
        return '90%';
      }
      return '93%';
    },
  },
};
</script>
